export const baseUrl = "https://poetry-app-server.onrender.com";
